import script from "./AdataPricePositioning.vue?vue&type=script&setup=true&lang=js"
export * from "./AdataPricePositioning.vue?vue&type=script&setup=true&lang=js"

import "./AdataPricePositioning.vue?vue&type=style&index=0&id=0dee1872&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dee1872"]])

export default __exports__